"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactMintl = require("@godaddy/react-mintl");
const useDisclaimerData = host => {
  const {
    formatMessage
  } = (0, _reactMintl.useIntl)();
  const getTermsUrl = article => `${host}/legal/agreements/${article}`;
  const getTerms = ({
    displayTextId,
    article
  }) => /*#__PURE__*/_react.default.createElement("a", {
    href: getTermsUrl(article)
  }, formatMessage({
    id: displayTextId
  }));
  const aiTerms = getTerms({
    article: 'ai-terms-of-use',
    displayTextId: 'aiTermsOfUse'
  });
  const universalTerms = getTerms({
    article: 'universal-terms-of-service-agreement',
    displayTextId: 'universalTermsOfService'
  });
  const privacyPolicy = getTerms({
    article: 'privacy-policy',
    displayTextId: 'privacyPolicy'
  });
  return {
    aiTerms,
    universalTerms,
    privacyPolicy
  };
};
var _default = exports.default = useDisclaimerData;